import { Card, Stack, Typography } from '@mui/material';
import React from 'react';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';

const CardMatSeccionesComponent = ({ data, onDelete, onEdit }) => {
  return (
    <Card sx={{ padding: 2 }}>
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Typography variant="h3" color="initial" fontWeight="bold">
          {data.seccion.nombre} -{' '}
          {data.seccion.nivelAcademico.nivelAcademico.abrev}
        </Typography>
        <div>
          <BotonComponent icon tooltip="Editar" editIcon click={onEdit} />
          {!data.aprobado && (
            <BotonComponent
              icon
              tooltip="Eliminar"
              deleteIcon
              click={onDelete}
            />
          )}
        </div>
      </Stack>

      <Typography variant="body1" color="initial">
        Sección: {data.seccion.nombre}
      </Typography>
      <Typography variant="body1" color="initial">
        Nivel académico: {data.seccion.nivelAcademico.nivelAcademico.nombre}
      </Typography>
      <Typography variant="body1" color="initial">
        Turno: {data.seccion.turno}
      </Typography>
      <Typography variant="body1" color="initial">
        Periodo academico: {data.periodoAcademico.nombre} (
        {data.periodoAcademico.desde}-{data.periodoAcademico.hasta})
      </Typography>
      <Typography variant="h6" color="initial">
        <strong>Aprobado:</strong> {data.aprobado ? 'Si' : 'No'}
      </Typography>
    </Card>
  );
};

export default CardMatSeccionesComponent;
